import { render, staticRenderFns } from "./proRecord.vue?vue&type=template&id=736d5f9a&scoped=true&"
import script from "./proRecord.vue?vue&type=script&lang=js&"
export * from "./proRecord.vue?vue&type=script&lang=js&"
import style0 from "./proRecord.vue?vue&type=style&index=0&id=736d5f9a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736d5f9a",
  null
  
)

export default component.exports